import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Navigation } from './Navigation';
import { Helmet } from 'react-helmet';
interface MainLayoutProps {
  onLogout?: () => void;
}
export function MainLayout({
  onLogout
}: MainLayoutProps) {
  const location = useLocation();
  // Set default meta tags that can be overridden by child components
  const defaultTitle = 'ScribeTok - TikTok Transcription Tool';
  const defaultDescription = 'Convert TikTok videos to readable transcripts instantly';
  const defaultImage = 'https://scribetok.com/og-image.jpg'; // Replace with your actual default image
  return <div className="min-h-screen bg-background flex flex-col md:flex-row" data-id="element-652">
      {/* Default meta tags for SEO and link previews */}
      <Helmet data-id="element-653">
        <title data-id="element-654">{defaultTitle}</title>
        <meta name="description" content={defaultDescription} data-id="element-655" />
        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" data-id="element-656" />
        <meta property="og:url" content={window.location.href} data-id="element-657" />
        <meta property="og:title" content={defaultTitle} data-id="element-658" />
        <meta property="og:description" content={defaultDescription} data-id="element-659" />
        <meta property="og:image" content={defaultImage} data-id="element-660" />
        <meta property="og:site_name" content="ScribeTok" data-id="element-661" />
        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" data-id="element-662" />
        <meta name="twitter:title" content={defaultTitle} data-id="element-663" />
        <meta name="twitter:description" content={defaultDescription} data-id="element-664" />
        <meta name="twitter:image" content={defaultImage} data-id="element-665" />
      </Helmet>
      <Navigation onLogout={onLogout} data-id="element-666" />
      <main className="flex-1 overflow-auto pb-20 md:pb-0 transition-all duration-200" data-id="element-667">
        <div className="animate-fade-in" data-id="element-668">
          <Outlet data-id="element-669" />
        </div>
      </main>
    </div>;
}